import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function VideosPage() {
  return <InstituteCrudPage config={entityConfigs['videos']} />;
}
